import * as partnerService from '../../../../data-layer/partner/service';
import {
    FnsStatusEnum,
    IERegistrationModel,
    LLCRegistrationModel,
    PartnerRegistrationErrorEnum,
    PartnerType,
    SERegistrationModel,
} from '../../../../data-layer/partner/types';
import {
    toIndividualEntrepreneurDto,
    toLLCDto,
    toSelfEmployedDto,
} from '../../../../mappers/partner/toPartnerRegistrationDto';
import { PartnerRegistrationUI } from '../../../../ui/business/PartnerRegistrationForm/types';

interface RegisterPartnerParams {
    partnerType: PartnerType;
    formValues: PartnerRegistrationUI;
}

export const registerPartner = async ({ partnerType, formValues }: RegisterPartnerParams) => {
    let dto;
    switch (partnerType) {
        case PartnerType.SE:
            dto = toSelfEmployedDto(formValues as SERegistrationModel);
            break;
        case PartnerType.IE:
            dto = toIndividualEntrepreneurDto(formValues as IERegistrationModel);
            break;
        case PartnerType.LLC:
            dto = toLLCDto(formValues as LLCRegistrationModel);
            break;
        default:
            throw new Error(`Unsupported partner type: ${partnerType}`);
    }

    await partnerService.postSignupExternalType(dto);

    if (partnerType === PartnerType.SE) {
        const { data } = await partnerService.getSignupExternalSelfEmployed();
        if (data.fns_status === FnsStatusEnum.UNREGISTERED) {
            throw new Error(PartnerRegistrationErrorEnum.UNREGISTERED);
        }

        return { fnsStatus: data.fns_status };
    }

    return {};
};
